export class Serie {
   name: string;
   value: number;

   constructor(name: string, value: number) {
       this.name = name;
       this.value = value;
   }    
}
